import { Button, Icon, Typography } from '@vp/swan'
import { useTranslations } from '~/app/features/Gallery/hooks/useTranslations'

interface SearchButtonProps {
  shouldHideText?: boolean
  onClick: () => void
}

export const SearchButton = ({ shouldHideText, onClick }: SearchButtonProps) => {
  const localize = useTranslations()

  return (
    <Button
      aria-label={localize('SearchPersonalizationButtonA11yText')}
      className="search-button"
      iconPosition="right"
      title={localize('HeaderHierarchySearchTemplates')}
      width={shouldHideText ? 'standard' : 'full-width'}
      onClick={onClick}
    >
      {!shouldHideText && (
        <Typography as="span" fontSize="standard" fontWeight="normal">
          {localize('HeaderHierarchySearchTemplates')}
        </Typography>
      )}
      <Icon alt="" iconType="search" />
    </Button>
  )
}

SearchButton.displayName = 'SearchButton'
